const BannerLinks = () => {
    return (
        <>

            <div className="Product_Background background-setting py-5" >
                <p className="futura fs_8 text-white m-0 text-center">Product</p>
            </div>
            <div className="Success_Background background-setting py-5" >
                <p className="futura fs_8 text-white m-0 text-center">Success</p>
            </div>
            <div className="About_Background background-setting py-5" >
                <p className="futura fs_8 text-white m-0 text-center">About</p>
            </div>
            <div className="Blog_Background background-setting py-5" >
                <p className="futura fs_8 text-white m-0 text-center">Blog</p>
            </div>
        </>
    )
}

export default BannerLinks